import React, { useEffect, useState } from 'react'
import { AlloMoniteur } from '../imgs/imgs';
import { Link } from 'react-scroll';

const Nav = () => {
    const [menu,setMenu] = useState(false)
  
    useEffect(() => {
      console.log(menu)
    }, [menu]);
    return (
      <div className='w-full flex flex-col justify-center items-center '>
      <div className='bg-gradient-to-l from-green-300 to-lime-400 w-full flex justify-center items-center py-[5px] text-center'>
      <p className='font-semibold py-[8px] text-[10px] md:text-[14px] px-[5px]'>Safety first, Driver education emphasizes the paramount importance of safety on the road. <span className=' text-[10px] underline cursor-pointer'>Read More</span> </p>  
      </div>
      <div className="w-[100%] flex justify-center items-center">
        <div className='max-w-[1600px] px-[10px] w-[100%] h-[75px]  flex relative'>
        <div className='logo  flex-0 md:flex-1 w-[15%] md:w-auto py-[8px] flex justify-center items-center'>
          <img src={AlloMoniteur} className=' h-[100%] w-[100%] object-contain'/>
        </div>
        <div className={` ${menu == false ? 'hidden':'flex left-0'} list w-[100%] md:w-[75%]  absolute md:relative top-[75px] md:top-0 h-auto py-[20px]  md:h-[100%] md:flex justify-center items-center bg-green-200 md:bg-white `}>
          <ul className={` flex  flex-col md:flex-row  justify-center items-center text-[16px] font-normal`}>
            
            <Link to="why" smooth={true} duration={500}>
            <li className='ml-[8px] mr-[12px] mb-[10px] md:mb-[0px] cursor-pointer'>Why we exist</li>
            </Link>
            <Link to="service" smooth={true} duration={500}>
            <li className='ml-[8px] mr-[12px] mb-[10px] md:mb-[0px] cursor-pointer'>Service</li>
            </Link>
            <Link to="waitlist" smooth={true} duration={500}>
            <li className='ml-[8px] mr-[12px] mb-[10px] md:mb-[0px] cursor-pointer'>Join our waitlist</li>
            </Link>
            <Link to="values" smooth={true} duration={500}>
            <li className='ml-[8px] mr-[12px] mb-[10px] md:mb-[0px] cursor-pointer'>Our Values</li>
            </Link>
            <li className='ml-[8px] md:ml-[28px] mr-[10px] mb-[10px] md:mb-[0px] cursor-pointer bg-green-300 px-[15px] py-[4px] rounded-md shadow-md font-medium'>Soon</li>
  
          </ul>
  
        </div>
        
        <div onClick={()=>setMenu(!menu)} className='menu  mr-[15px] w-[40px] h-[40px] flex flex-col justify-center items-center absolute right-0 top-[16px] md:hidden cursor-pointer'>
          <div className={` ${menu == true ? 'transform rotate-45 mb-[0px]':'transform rotate-0 mb-[5px]'} delay-50  line w-[100%] bg-green-600 h-[7px] overflow-hidden rounded-sm`}> <div className='text-blue-600'></div> </div>
          <div className={` ${menu == true ? 'transform rotation mt-[-7px]':'transform rotate-0 mb-[5px]'} delay-50 line w-[100%] bg-green-700 h-[7px] overflow-hidden rounded-sm`}> <div className='text-blue-600'></div> </div>
          <div className={` ${menu == true ? 'hidden':'flex'} delay-150 line w-[100%] bg-green-800 h-[7px] overflow-hidden rounded-sm`}> <div className='text-green-600'></div> </div>
  
        </div>
        </div>
        
      </div>
      </div>
    )
}

export default Nav
